
import React from 'react';
import classNames from 'classnames';
import css from './ScrollBar.module.scss';


// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface IProps {
    scrollVertical?: boolean;
    scrollHorizontal?: boolean;
    theme?: string;
}

const ScrollBar = (props) => {
    let themeColor = getComputedStyle(document.documentElement).getPropertyValue('--scrollbarThumb');
    if (props.theme === 'lexus' || props.theme === 'lexusMonogram') {
        themeColor = getComputedStyle(document.documentElement).getPropertyValue('--textColor');
    }
    updateScrollbarColor(themeColor, props.theme);

    const className = classNames(
        css.scrollBar,
        {
            [css.horizontal]: props.scrollHorizontal,
            [css.vertical]: props.scrollVertical,
        },
    );

    return (
        <div className={className} key={props.theme}>
            {props.children}
        </div>
    );
};

export default ScrollBar;

// #region Functions
// The generateArrow functions allows us to change the color of the button, which CSS can not do to an external SVG
function generateLeftArrowSVG(color: string) {
    const leftArrowSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="` + color +
    `" width="30" height="20"><path d="M8 12L14 6V18L8 12Z"></path></svg>`;

    return `url('data:image/svg+xml;utf8,${encodeURIComponent(leftArrowSVG)}')`;
}

function generateRightArrowSVG(color: string) {
    const rightArrowSVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="` + color +
    `" width="30" height="20"><path d="M16 12L10 18V6L16 12Z"></path></svg>`;

    return `url('data:image/svg+xml;utf8,${encodeURIComponent(rightArrowSVG)}')`;
}

function updateScrollbarColor(themeColor: string, theme: string) {
    const leftEncodedSVG = generateLeftArrowSVG(themeColor);
    const rightEncodedSVG = generateRightArrowSVG(themeColor);
    const dividerColor = getComputedStyle(document.documentElement).getPropertyValue('--dividerColor');
    const adabackground = getComputedStyle(document.documentElement).getPropertyValue('--backgroundcolor');

    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    if (theme === 'colorSensitive') {
        styleSheet.innerText = `
        ::-webkit-scrollbar-track:horizontal {
            background-color: ${adabackground};
        }
        ::-webkit-scrollbar-button:horizontal:increment {
            background-image: ${rightEncodedSVG};
            background-color: ${adabackground};
        }

        ::-webkit-scrollbar-button:horizontal:decrement {
            background-image: ${leftEncodedSVG};
            background-color: ${adabackground};
        }
    `;
    } else {
        styleSheet.innerText = `
        ::-webkit-scrollbar-track:horizontal {
            background-color: ${dividerColor};
        }
        ::-webkit-scrollbar-button:horizontal:increment {
            background-image: ${rightEncodedSVG};
            background-color: ${dividerColor};
        }

        ::-webkit-scrollbar-button:horizontal:decrement {
            background-image: ${leftEncodedSVG};
            background-color: ${dividerColor};
        }
    `;
    }

    document.head.appendChild(styleSheet);
}
// #endregion